import { Col, Row, Typography } from "antd";

const { Text } = Typography;

// Define the props to expect the 'user' object
interface BasicInfoProps {
  user: any; // Or a more specific interface if you have one
}

// A simple component to display a single piece of info
const InfoItem = ({ label, value }: { label: string; value: string }) => (
  <Col xs={24} sm={12} md={6}>
    <Text type="secondary">{label} :</Text>
    <br />
    <Text style={{ textTransform: "capitalize" }}>{value || "-"}</Text>
  </Col>
);

export const BasicInfo: React.FC<BasicInfoProps> = ({ user }) => {
  return (
    <div>
      <h3 style={{ marginBottom: "20px", fontWeight: "bold" }}>
        Basic Information
      </h3>
      <Row gutter={[16, 16]}>
        <InfoItem label="Date of Birth" value={user.dateOfBirth} />
        <InfoItem label="Email" value={user.email} />
        <InfoItem label="Phone Number" value={user.phoneNumber} />
        <InfoItem label="Gender" value={user.gender} />
      </Row>
    </div>
  );
};